import { EMRdetailsProps, IEMRUpdatePayloadProps } from "@/api_framework/api_modals/EMRs";
import RemarksTextarea from "@/app/components/ui/RemarksTextarea";
import { usePetBodyandDentalScoreAPI } from "@/app/hooks/api_hooks/emr/usePetBodyandDentalScoreAPI";
import { useUpdateTempEMRAPI } from "@/app/hooks/api_hooks/emr/useUpdateTempEMRAPI";
import { useEffect, useState } from "react";

type SectionType = "body_condition_score" | "dental_score";

const HealthScoreDetailsComponent = ({ emrDetails, setEmrDetails, errorMessage, setErrorMessage }: EMRdetailsProps) => {
  const [selectedBodyScore, setSelectedBodyScore] = useState<any>(null);
  const [selectedDentalScore, setSelectedDentalScore] = useState<any>(null);

  const [bodyScoreItems, setBodyScoreItems] = useState<any>(null);
  const [dentalScoreItems, setDentalScoreItems] = useState<any>(null);

  const [initalLoad, setInitalLoad] = useState(false);

  const { execute: updateEmrAPI } = useUpdateTempEMRAPI();
  const { execute: fetchPetHelthDetailsAPI, petHelthDetails } = usePetBodyandDentalScoreAPI();

  const params = new URLSearchParams(location.search);
  const emr_id = params.get("emr_id");

  useEffect(() => {
    fetchPetHelthDetailsAPI();
  }, []);

  const updateEmrDetails = (value: number, section: SectionType) => {
    const constructedBody: IEMRUpdatePayloadProps = {
      [section]: value,
      body_condition_score: section === "body_condition_score" ? value : emrDetails.body_condition_score,
      dental_score: section === "dental_score" ? value : emrDetails.dental_score,
      emr_status: emrDetails?.emr_status,
    };

    updateEmrAPI(emr_id, constructedBody).then(({ status, message }) => {
      if (status) {
        setEmrDetails(message);
      }
    });
  };
  const handleUpdate = (value: any, section: SectionType) => {
    if (section === "body_condition_score") {
      setSelectedBodyScore(value);
    } else {
      setSelectedDentalScore(value);
    }

    updateEmrDetails(value?.score, section);

    setErrorMessage((prev: string[] | null) => {
      if (!prev) return prev;

      const fieldLabels: Record<SectionType, string> = {
        body_condition_score: "Body Condition Score",
        dental_score: "Dental Score",
      };

      const label = fieldLabels[section];
      return prev.filter((msg) => msg !== label);
    });
  };

  useEffect(() => {
    if (emrDetails && bodyScoreItems && dentalScoreItems)
      if (bodyScoreItems) {
        const bodyScoreItem = bodyScoreItems.find((item) => item.score === emrDetails.body_condition_score);
        setSelectedBodyScore(bodyScoreItem || null);
      }

    if (dentalScoreItems) {
      if (emrDetails.dental_score === null || emrDetails.dental_score === undefined) {
        setSelectedDentalScore(null);
      } else {
        const dentalScoreItem = dentalScoreItems.find((item) => item.score === emrDetails.dental_score);
        setSelectedDentalScore(dentalScoreItem || null);
      }
    }
  }, [emrDetails, bodyScoreItems, dentalScoreItems]);

  useEffect(() => {
    if (emrDetails && petHelthDetails && !initalLoad) {
      const isCat = emrDetails?.pet_details?.pet_specie === "Feline";

      const bodyScore = isCat ? petHelthDetails?.cat_body_condition_score : petHelthDetails?.dog_body_condition_score;

      const dentalScore = isCat ? petHelthDetails?.cat_dental_score : petHelthDetails?.dog_dental_score;

      setBodyScoreItems(bodyScore);
      setDentalScoreItems(dentalScore);

      setInitalLoad(true);
    }
  }, [emrDetails, petHelthDetails, initalLoad]);

  return (
    <div className=" w-full py-3 bg-white p-3 rounded-[10px] mt-3 ">
      <div className="  mt-2 rounded-[10px] bg-[#F9FAFB]">
        <h3 className="text-[#000000] text-sm font-medium tracking-tight42 p-2">
          Body Condition Score{" "}
          {errorMessage?.includes("Body Condition Score") && (
            <span className="text-red-500 pl-4 text-xs">Pick one option to finish EMR</span>
          )}
        </h3>
        <div className="bg-[#F9FAFB] w-full rounded-xl px-2 flex gap-3 flex-col">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
            {bodyScoreItems?.map((score, _id) => {
              return (
                <div
                  className={` ${selectedBodyScore?.score === score.score ? "border-[#000000] " : " border-[#E2E2E2]"} bg-[#FFFFFF] border rounded-xl p-[10px]   flex items-center justify-center flex-col gap-2 cursor-pointer`}
                  key={score?.score}
                  onClick={() => handleUpdate(score, "body_condition_score")}
                >
                  <div className="w-full h-[110px]">
                    <img src={score?.icon} alt={score?.title} className="w-full h-full object-contain rounded-xl" />
                  </div>

                  <p
                    className={` ${selectedBodyScore?.score === score.score ? "text-[#000000]" : "text-[#6C727F]"} font-medium text-sm `}
                  >
                    {score?.score}. {score?.title}
                  </p>
                </div>
              );
            })}
          </div>
          <RemarksTextarea value={selectedBodyScore?.remark} />
        </div>
      </div>
      <div className="  mt-2 rounded-[10px] bg-[#F9FAFB]">
        <h3 className="text-[#000000] text-sm font-medium tracking-tight42 p-2">
          Dental Score{" "}
          {errorMessage?.includes("Dental Score") && (
            <span className="text-red-500 pl-4 text-xs">Pick one option to finish EMR</span>
          )}
        </h3>

        <div className="flex gap-3 flex-wrap font-medium px-2 ">
          <div className="bg-[#F9FAFB] w-full rounded-xl flex gap-3 flex-col">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
              {dentalScoreItems?.map((item, _id) => {
                return (
                  <div
                    className={` ${selectedDentalScore?.score === item.score ? "border-[#000000] " : " border-[#E2E2E2]"} bg-[#FFFFFF] border rounded-xl p-[10px] flex items-center justify-center flex-col gap-2 cursor-pointer`}
                    key={item?.score}
                    onClick={() => handleUpdate(item, "dental_score")}
                  >
                    <div className="w-full h-[110px]">
                      <img src={item?.icon} alt={item?.title} className="w-full h-full object-contain rounded-xl" />
                    </div>
                    <p
                      className={` ${selectedDentalScore?.score === item.score ? "text-[#000000]" : "text-[#6C727F]"} font-medium text-sm `}
                    >
                      {item?.score}. {item?.title}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
          <RemarksTextarea value={selectedDentalScore?.remark} />
        </div>
      </div>
    </div>
  );
};
export default HealthScoreDetailsComponent;
